document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('.hair-quiz');
  if (!root) return;

  const mappingData = JSON.parse(document.getElementById('quiz-mapping-data').textContent);
  const currentHandle = root.dataset.currentHandle;
  const metafieldGender = root.dataset.currentGender; // fallback only

  const state = { gender: null, stage: null, age: null, duration: null, pack: '1' };

    // --- Priority 1: URL params (exact user selection, unambiguous) ---
  const urlParams = new URLSearchParams(window.location.search);
  const hasUrlState = urlParams.has('g') && urlParams.has('s') && urlParams.has('a') && urlParams.has('d');

  if (hasUrlState) {
    state.gender = urlParams.get('g');
    state.stage = urlParams.get('s');
    state.age = urlParams.get('a');
    state.duration = urlParams.get('d');
  } else {
    // --- Priority 2: reverse lookup by handle (ambiguous fallback, best-effort) ---
    const currentEntry = mappingData.find(m => m.handle === currentHandle);
    if (currentEntry) {
      state.gender = currentEntry.gender;
      state.stage = currentEntry.stage;
      state.age = currentEntry.age;
      state.duration = currentEntry.duration;
    } else if (metafieldGender) {
      state.gender = metafieldGender;
    }
  }

  const savedPack = sessionStorage.getItem('hairquiz_pack');
  if (savedPack) state.pack = savedPack;

  // default any still-unset group to its first option
  root.querySelectorAll('.hair-quiz__group').forEach(group => {
    const key = group.dataset.group;
    if (!state[key]) {
      state[key] = group.querySelector('.hair-quiz__option').dataset.value;
    }
  });

  function paintSelections() {
    root.querySelectorAll('.hair-quiz__group').forEach(group => {
      const key = group.dataset.group;
      const value = state[key];
      group.querySelectorAll('.hair-quiz__option').forEach(btn => {
        btn.classList.toggle('is-selected', btn.dataset.value === value);
      });
    });
  }

  function updateGenderVisuals() {
    root.dataset.activeGender = state.gender;
    root.querySelectorAll('.hair-quiz__stage-label').forEach(span => {
      span.textContent = state.gender === 'female'
        ? span.dataset.labelFemale
        : span.dataset.labelMale;
    });
  }

  paintSelections();
  updateGenderVisuals();

  root.querySelectorAll('.hair-quiz__option').forEach(btn => {
    btn.addEventListener('click', function () {
      const group = btn.closest('.hair-quiz__group').dataset.group;
      state[group] = btn.dataset.value;
      paintSelections();

      if (group === 'gender') {
        updateGenderVisuals(); // swap images/labels immediately, then redirect
      }

      if (group === 'pack') {
        sessionStorage.setItem('hairquiz_pack', state.pack);
        applyQuantity(state.pack);
        return; // pack never redirects
      }

      resolveAndRedirect();
    });
  });

function resolveAndRedirect() {
  const match = mappingData.find(m =>
    m.gender === state.gender &&
    m.stage === state.stage &&
    m.age === state.age &&
    m.duration === state.duration
  );

  if (!match) {
    console.warn('No product mapping found for this combination', state);
    console.log('Available mappings:', mappingData);
    return;
  }

  console.log('Available mappings:', mappingData);

  sessionStorage.setItem('hairquiz_pack', state.pack);

  const params = new URLSearchParams({
    g: state.gender,
    s: state.stage,
    a: state.age,
    d: state.duration
  });

  if (match.handle === currentHandle) {
    // still update the URL so refresh/back-forward preserves the exact selection
    history.replaceState(null, '', `?${params.toString()}`);
    window.location.reload();
    return;
  }

  window.location.href = `/products/${match.handle}?${params.toString()}`;
}

  function applyQuantity(pack) {
    const qtyInput = document.querySelector('input[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = pack;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  applyQuantity(state.pack);
});